import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { sendPageLand } from "./utils/telemetry";

sendPageLand();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
